const FormService = {
  hasError(key, errorsForm, errorsApi) {
    return (errorsApi && errorsApi[key]) || (errorsForm && errorsForm[key]);
  }
};

export default FormService;